var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-EXPONDO-white rounded-full border border-EXPONDO-primary-20"},[_c('div',{staticClass:"relative bg-EXPONDO-primary-20 rounded-full border border-EXPONDO-primary-40 w-1/3 h-full",style:({
      width: _vm.indicatorWidth,
      left: _vm.indicatorPosition
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }